export default __webpack_public_path__ + "static/media/ATTACCO_CARDIACO_ICONA12.ae349dd9.svg";